/* eslint-disable */

export const GET_CURRENCIES_ALL = {
    GET_CURRENCIES_ALL_REQUEST: 'GET_CURRENCIES_ALL_REQUEST',
    GET_CURRENCIES_ALL_SUCCESS: 'GET_CURRENCIES_ALL_SUCCESS',
    GET_CURRENCIES_ALL_FAILURE: 'GET_CURRENCIES_ALL_FAILURE',
};
